import React from 'react';
import { ClickableText } from 'core/components';
import PlanCalloutWrapper from 'app/views/licenses/v2/layout/PlanCalloutWrapper';

const FpsAlert = ({
  type,
  avgConfiguredSamplingRate,
  dataResolution,
  openContactAccountTeamDialog,
  receivedExceedsMaxFps = false
}) => {
  let shouldShow = false;
  let intent;
  let message;
  let icon;
  const msgCopy = 'high for your current plan.';
  if (type === 'raw' && avgConfiguredSamplingRate && avgConfiguredSamplingRate !== 'N/A') {
    // Parse the sampling rate (e.g., "1:2.5" -> 2.5)
    const parseSamplingRate = (rateString) => {
      const match = rateString.match(/^1:(\d+(?:\.\d+)?)$/);
      return match ? parseFloat(match[1]) : null;
    };

    const samplingRatio = parseSamplingRate(avgConfiguredSamplingRate);

    // Show alert if sampling rate is more than 1:1
    if (samplingRatio && samplingRatio > 1) {
      shouldShow = true;
      if (samplingRatio > 2) {
        // More than 1:2 - red/pink alert
        intent = 'danger';
        icon = 'cross-circle';
        message = `Raw FPS is very ${msgCopy}`;
      } else {
        // More than 1:1 up to 1:2 - yellow alert
        intent = 'warning';
        icon = 'warning-sign';
        message = `Raw FPS is ${msgCopy}`;
      }
    }
  } else if (type === 'received' && receivedExceedsMaxFps && dataResolution) {
    // Only show received FPS alerts when received actually exceeds the plan max FPS.
    // dataResolution determines severity: 'low' = danger, 'downsampled' = warning.
    shouldShow = true;
    if (dataResolution === 'low') {
      // Red/pink alert for low resolution
      intent = 'danger';
      icon = 'cross-circle';
      message = `Received FPS is very ${msgCopy}`;
    } else if (dataResolution === 'downsampled') {
      // Yellow alert for downsampled
      intent = 'warning';
      icon = 'warning-sign';
      message = `Received FPS is ${msgCopy}`;
    }
  }

  if (!shouldShow || !message) {
    return null;
  }

  return (
    <PlanCalloutWrapper intent={intent} icon={icon}>
      {message}
      <ClickableText onClick={openContactAccountTeamDialog}>Please contact your account team.</ClickableText>
    </PlanCalloutWrapper>
  );
};

export default FpsAlert;
